import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import { EntityCategoryFragment } from './fragments';

export const CREATE_ENTITY_CATEGORY = gql`
  mutation EntityCategoryCreate($input: EntityCategoryCreateInput!) {
    entityCategoryCreate(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...EntityCategoryFields
      }
    }
  }
  ${EntityCategoryFragment}
  ${ErrorFragment}
`;
